import React, { useState } from 'react';
import inventory from "../../assets/portfolio/inventory.webp";
import bricks from "../../assets/portfolio/bricks.webp";
import facebook from "../../assets/portfolio/facebook.webp";
import food from "../../assets/portfolio/food.webp";
import lemongrass from "../../assets/portfolio/lemongrass.webp";
import news from "../../assets/portfolio/news.webp";
import pizza from "../../assets/portfolio/pizza.webp";
import portfolio from "../../assets/portfolio/portfolio.webp";
import spareparts from "../../assets/portfolio/spareparts.webp";
import adorable from "../../assets/portfolio/adorable.webp";
import dgs from "../../assets/portfolio/dgs.webp";
import dreamprints from "../../assets/portfolio/dreamprints.webp";
import EthicsWala from "../../assets/ethicswalaicon.webp";

import mgstech  from "../../assets/portfolio/mgstech.webp";
import photobegin  from "../../assets/portfolio/photobegin.webp";
import snow  from "../../assets/portfolio/snowmachine.webp";
import jhakkash from "../../assets/portfolio/jhakkash.webp";

import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'

import { IoClose } from "react-icons/io5";
import { HiMenuAlt1 } from "react-icons/hi";
import { FaRegBell } from "react-icons/fa";
import { Link } from 'react-router-dom';

const navigation = [
  { name: 'Portfolios', href: '/portfolios', current: true },
  { name: 'Team', href: '#', current: false },
  { name: 'Projects', href: '#', current: false },
  
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Portfolios = () => {
    const [open, setOpen] = useState(false);

    const portfolios = [
        { id: 1, src: mgstech, text: "E-commerce Website", link: "https://mgstechworld.in/" },
        { id: 2, src: portfolio, text: "Portfolio App" },
        { id: 3, src: food, text: "Food Ordering Website" },
        { id: 4, src: spareparts, text: "Showroom Management App", link: "https://axiomaticspares.com" },
        { id: 5, src: bricks, text: "Bengal Bricks Nandakumar", link: "https://bengalbricks.netlify.app" },
        { id: 6, src: facebook, text: "Facebook Clone App" },
        { id: 7, src: lemongrass, text: "Tea Garden Website" },
        { id: 8, src: pizza, text: "Pizza Delivery App" },
        { id: 9, src: news, text: "News Website / App" },
        { id: 10, src: adorable, text: "Tourism Website", link: "https://adorablevacation.com" },
        { id: 11, src: dgs, text: "Companies Profile", link: "https://dgsinfotech.netlify.app" },
        { id: 12, src: snow, text: "Anime Website / App" },
        { id: 13, src: dreamprints, text: "E-commerce Website", link: "https://dreamprints.in" },
        { id: 14, src: photobegin, text: "Photographes Plartform ", link: "https://fotobegin.com/" },
        { id: 15, src: jhakkash, text: "E-commerce Website", link: "https://jhakkash.in/" },
        { id: 16, src: inventory, text: "Inventory Management App" },
    ];

    const handleClick = (link) => {
        if (link) {
            window.open(link, '_blank'); // Opens the link in a new tab
        } else {
            setOpen(true); // Opens the modal
        }
    };

    return (
        <>
         {/* <--------------------- nav bar -----------------------> */}
<Disclosure as="nav" className="bg-gray-800 lg:pb-[100px] ">
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div className="relative flex h-16 items-center justify-between">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            {/* Mobile menu button*/}
            <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset">
              <span className="absolute -inset-0.5" />
              <span className="sr-only">Open main menu</span>
              <HiMenuAlt1 aria-hidden="true" className="block size-6 group-data-open:hidden" />
              <IoClose aria-hidden="true" className="hidden size-6 group-data-open:block" />
            </DisclosureButton>
          </div>
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div className="flex shrink-0 items-center">
             <Link to="/"> 
             <img
                alt="Your Company"
                src={EthicsWala}
                className="h-8 w-auto rounded-full border-white border-[1px]"
              />
              </Link>
            </div>
            <div className="hidden sm:ml-6 sm:block">
              <div className="flex space-x-4">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    aria-current={item.current ? 'page' : undefined}
                    className={classNames(
                      item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                      'rounded-md px-3 py-2 text-sm font-medium',
                    )}
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            <button
              type="button"
              className="relative rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 focus:outline-hidden"
            >
              <span className="absolute -inset-1.5" />
              <span className="sr-only">View notifications</span>
              <FaRegBell aria-hidden="true" className="size-6" />
            </button>

            {/* Profile dropdown */}
            <Menu as="div" className="relative ml-3">
              <div>
                <MenuButton className="relative flex rounded-full bg-gray-800 text-sm focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 focus:outline-hidden">
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">Open user menu</span>
                  <img
                    alt=""
                    src="https://ethicswalacoder.netlify.app/static/media/ethicswala1.2836c8afbd3aa92a882a.webp"
                    className="h-8 rounded-full"
                  />
                </MenuButton>
              </div>
              <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 ring-1 shadow-lg ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
              >
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                  >
                    Your Profile
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                  >
                    Settings
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                  >
                    Sign out
                  </a>
                </MenuItem>
              </MenuItems>
            </Menu>
          </div>
        </div>
      </div>

      <DisclosurePanel className="sm:hidden">
        <div className="space-y-1 px-2 pt-2 pb-3">
          {navigation.map((item) => (
            <DisclosureButton
              key={item.name}
              as="a"
              href={item.href}
              aria-current={item.current ? 'page' : undefined}
              className={classNames(
                item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                'block rounded-md px-3 py-2 text-base font-medium',
              )}
            >
              {item.name}
            </DisclosureButton>
          ))}
        </div>
      </DisclosurePanel>
    </Disclosure>

{/* <--------------------- nav bar -----------------------> */}
        <div name="portfolio" className="bg-gradient-to-b from-gray-800 to-black w-full text-white md:h-auto ">



        <div className="max-w-screen  mx-auto flex flex-col justify-center w-full h-full lg:px-[150px]">
               
                <div className="pb-10 text-center" data-aos="fade-right" data-aos-duration="1800">
                    <h1 className="lg:text-5xl text-3xl inline border-b-4 border-gray-500 text-center items-center">Portfolios</h1>
                    
                </div>

                <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 px-12 sm:px-0" data-aos="fade-up" data-aos-duration="2000">
                    {portfolios.map(({ id, src, text, link }) => (
                        <div key={id} className="shadow-md shadow-gray-400 rounded-lg">
                            <div className="relative block bg-black group rounded-lg">
                                <img className="absolute overflow-hidden inset-0 object-cover w-full h-full md:min-h-full group-hover:opacity-50 rounded-lg" src={src} alt={text} width={"100%"} height={"100%"} />
                                <div className="relative p-5">
                                    <div className="mt-5 md:mt-14">
                                        <div className="transition-all transform translate-y-8 opacity-0 group-hover:opacity-100 group-hover:translate-y-0">
                                            <div className="p-2">
                                                <p className="text-sm md:text-md text-white"><strong>{text}</strong></p>
                                                <button
                                                    className="px-4 py-2 text-sm text-white bg-gradient-to-b from-cyan-500 to-blue-500 rounded-lg"
                                                    onClick={() => handleClick(link)}
                                                >
                                                    Visit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {open && (
                        <div className="fixed inset-0 flex justify-center items-center overflow-x-hidden overflow-y-auto bg-black/30 backdrop-blur-sm z-50">
                            <div className="relative w-auto my-6 mx-auto max-w-xl">
                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none">
                                    <div className="flex items-start justify-between md:p-5 p-3 border-b border-solid border-gray-300 rounded-t">
                                        <h3 className="md:text-3xl font-semibold text-black">🙏 Welcome</h3>
                                        <button
                                            className="bg-transparent border-0 text-black float-right"
                                            onClick={() => setOpen(false)}
                                        >
                                            <span className="text-black opacity-7 h-6 w-6 md:text-3xl text-xl block">x</span>
                                        </button>
                                    </div>
                                    <div className="relative p-2 md:p-6 flex-auto">
                                        <div className="shadow-md shadow-gray-600 rounded-lg text-black p-5">
                                            <h2 className="animate-text bg-gradient-to-r from-teal-500 via-purple-500 to-orange-500 bg-clip-text text-transparent md:text-5xl font-black">
                                                Processing...<br />
                                                Under Development!
                                            </h2>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end p-2 md:p-6 border-t border-solid border-blueGray-200 rounded-b">
                                        <button
                                            className="text-white bg-red-600 active:bg-red-800 font-bold uppercase text-sm md:px-6 md:py-3 px-4 py-1 rounded shadow hover:shadow-lg outline-none"
                                            type="button"
                                            onClick={() => setOpen(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
               


            </div>
            
        </div>
        </>
        
    );
}

export default Portfolios;
